
import DateFilter from '../../../../../common/components/listControl/dateFilter/DateFilter'
import { Range } from '../../../../../common/types/interfaces'
import classes from './Filters.module.sass'

type Preset = 'today' | 'week' | 'month' | 'custom'

type Props = {
  preset: Preset
  changePreset: (p: Preset) => void
  range: Range
  onRangeChange: (value: string, first?: boolean) => void
}

const PRESETS: { key: Preset; label: string }[] = [
  { key: 'today', label: 'День' },
  { key: 'week', label: 'Неделя' },
  { key: 'month', label: 'Месяц' },
]

export const Filters = ({ preset, changePreset, range, onRangeChange }: Props) => {
  return (
    <div className={classes.row}>
      <div className={classes.tabs}>
        {PRESETS.map((p) => (
          <button
            key={p.key}
            className={`${classes.tab} ${preset === p.key ? classes.active : ''}`}
            onClick={() => changePreset(p.key)}
          >
            {p.label}
          </button>
        ))}
      </div>
      <DateFilter range={range} onChange={onRangeChange} />
    </div>
  )
}
